import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createContactPersonNote } from "../../api/contactPersons";

const useCreateContactPersonNote = (contactPersonId: number, onSuccess: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (note: string) => createContactPersonNote(contactPersonId, { note }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contactPersonNotes", contactPersonId] });
      onSuccess();
    },
  });
};

export default useCreateContactPersonNote;
